import React from 'react';
import classNames from 'classnames';

const VersionIcon = ({
  className, size, ...rest
}) => (
  <svg className={classNames(`w-${size} h-${size}`, className)} aria-label="version" viewBox="0 0 100 100" {...rest}>
    <path d="M89.58,13.83H57.25a6,6,0,0,0-6,6v2H28.92a6,6,0,0,0-6,6v2H10.42a6,6,0,0,0-6,6V64.17a6,6,0,0,0,6,6h12.5v2a6,6,0,0,0,6,6H51.25v2a6,6,0,0,0,6,6H89.58a6,6,0,0,0,6-6V19.83A6,6,0,0,0,89.58,13.83ZM10.42,64.17V35.83h12.5V64.17Zm18.5,8V27.83H51.25V72.17Zm28.33,8V19.83H89.58V80.17Z"/>
  </svg>
)

export default VersionIcon;
